export interface FounderScoreInput {
  strengthScore?: number;
  workoutCount?: number;
  streakDays?: number;
  referralCount?: number;
}

export interface FounderScoreResult {
  score: number;
  breakdown: {
    strength: number;
    consistency: number;
    streak: number;
    referrals: number;
  };
}

export function computeFounderScore({
  strengthScore = 0,
  workoutCount = 0,
  streakDays = 0,
  referralCount = 0,
}: FounderScoreInput): FounderScoreResult {
  const strength = strengthScore * 0.4;
  const consistency = workoutCount * 2 * 0.2;
  const streak = streakDays * 1.5 * 0.2;
  const referrals = referralCount * 10 * 0.2;
  const score = strength + consistency + streak + referrals;
  return {
    score: Math.round(score * 10) / 10,
    breakdown: { strength, consistency, streak, referrals },
  };
}
